const getTrackingEstimatedTimeOfDeliveryTitleStyles = theme => ({
  color: theme.palette.gray.main
});
const getTrackingEstimatedTimeOfDeliveryDateErrorStyles = theme => ({
  color: theme.palette.error.main
});

export { getTrackingEstimatedTimeOfDeliveryDateErrorStyles, getTrackingEstimatedTimeOfDeliveryTitleStyles };
//# sourceMappingURL=TrackingEstimatedTimeOfDeliveryStyles.js.map
